export default "__VITE_ASSET__DdakQjNL__"